<template>
  <RouterView />
</template>

<script>
export default {

}
</script>

<style lang="less" scoped>

</style>>
